import * as React from 'react';
export var AvatarContext = React.createContext({
    size: 'medium',
});
export var useAvatarContext = function () { return React.useContext(AvatarContext); };
